
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWaypointEditIec as ObiWaypointEditIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-waypoint-edit-iec.js';
 
 
 

 
 export const ObiWaypointEditIec = createComponent({
   react: React,
   tagName: 'obi-waypoint-edit-iec',
   elementClass: ObiWaypointEditIecElement,
   events: {
     
   }
  });
 
 